import { Injectable } from "@angular/core";
import { Cache, CacheFactory } from 'cachefactory';
import { merge, isEmpty } from 'lodash';
import { CacheService } from './cache.service';

@Injectable()
export class CacheFactoryCacheService extends CacheService {

  private cacheFactory: CacheFactory;
  private defaultOptions: any = {};
  static DEFAULT_CACHE: string = 'uw-cache';

  constructor() {
    super();
    this.cacheFactory = new CacheFactory();
    this.defaultOptions = {
      // Check for expired items every 60 seconds
      recycleFreq: 60 * 1000,
      maxAge: 60 * 60 * 1000,
      capacity: 100,
      // Items will be deleted from this cache right when they expire
      deleteOnExpire: 'aggressive',
      // This cache will use `localStorage`
      storageMode: 'memory'
      // storageMode: 'localStorage'
    }
  }

  /**
   * Creates the Cache if doesn't exists. Return the Cache Object from the CacheFactory
   * @param name
   * @param options
   * @returns {Cache}
   */
  createCache(name: string, options: any = {}) {
    if (!!options || isEmpty(options)) {
      options = this.defaultOptions;
    } else {
      options = merge(this.defaultOptions, options);
    }

    return this.cacheFactory.createCache(name, options);
  }

  /**
   * Get the Cache Object
   * @param name
   * @returns {Cache}
   */
  getCache(name?: string, options?: any): Cache {
    if (!!name && this.cacheFactory.exists(name)) {
      return this.cacheFactory.get(name);
    } else if (this.cacheFactory.exists(CacheFactoryCacheService.DEFAULT_CACHE)) {
      return this.cacheFactory.get(CacheFactoryCacheService.DEFAULT_CACHE);
    } else {
      return this.createCache(!!name ? name : CacheFactoryCacheService.DEFAULT_CACHE, options);
    }
  }

  /**
   * Clear the Cache Object
   * @param name
   */
  clearCache(name: string) {
    if (this.cacheFactory.exists(name)) {
      this.cacheFactory.destroy(name);
    }
  }

  /**
   * Get the value from Cache
   * @param cache
   * @param key
   */
  get(key: string, cache?: string) {
    return this.getCache(cache).get(key);
  }

  /**
   * Remove a Key from the Cache.
   * @param name
   * @param key
   */
  remove(key: string, cache?: string) {
    this.getCache(cache).remove(key);
  }

  /**
   * Add Object to Cache
   * @param key
   * @param value
   * @param cache
   */
  put(key: string, value: any, cache?: string, cacheOptions?: any) {
    this.getCache(cache, cacheOptions).put(key, value);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/cachefactory.service.ts